import * as Sentry from "@sentry/react";
Sentry.init({
  dsn: "https://def51ddf0c84dae7e68d400f86201e7e@o102901.ingest.us.sentry.io/4509429195997184",
  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
  integrations: [],
  enabled: process.env.NODE_ENV === "production",
});
